import { createRouter, createWebHashHistory } from 'vue-router';

import { createChunkReloadHandler } from './chunkReloadHandler';
import authGuard from './guards/authGuard';
import {
  tenantAvailabilityGuard,
  tenantSelectionGuard
} from './guards/tenantGuards';
import trackingHook from './guards/trackingHook';
import utmCaptureGuard from './guards/utmCaptureGuard';
import routes from './routes';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Return to saved position when using browser back/forward
    return savedPosition || { top: 0 };
  }
});

// Register guards — ordering is load-bearing:
// UTM capture must run before auth redirects strip campaign params, and tenant
// availability must be checked before tenant selection is committed to the store.
router.beforeEach(utmCaptureGuard);
router.beforeEach(authGuard);
router.beforeEach(tenantAvailabilityGuard);
router.beforeResolve(tenantSelectionGuard);
router.afterEach(trackingHook);

// Recover from stale-deployment chunk load failures (see chunkReloadHandler.ts)
router.onError(createChunkReloadHandler(router));

export default router;
